interface FAQ {
  q: string;
  a: string;
}

interface FAQSectionProps {
  faqs: FAQ[];
  title?: string;
  subtitle?: string;
}

const FAQSection = ({
  faqs,
  title = "Perguntas Frequentes",
  subtitle = "Respostas rápidas para as dúvidas mais comuns de quem fala com a gente.",
}: FAQSectionProps) => (
  <section id="faq" className="py-16 md:py-24" aria-labelledby="faq-heading">
    <div className="container">
      <div className="mx-auto mb-10 max-w-2xl text-center">
        <h2 id="faq-heading" className="mb-3 text-2xl font-extrabold text-foreground sm:text-3xl">
          {title}
        </h2>
        <p className="text-sm text-muted-foreground">{subtitle}</p>
      </div>
      <div className="mx-auto max-w-2xl space-y-4">
        {faqs.map((faq) => (
          <details
            key={faq.q}
            className="group rounded-lg border border-border bg-card p-4 shadow-card"
          >
            <summary className="cursor-pointer text-sm font-bold text-foreground">
              {faq.q}
            </summary>
            <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{faq.a}</p>
          </details>
        ))}
      </div>
    </div>
  </section>
);

export default FAQSection;
